import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';

import { InlineSvgComponent } from '../inline-svg/inline-svg.component';

export type TagColor = 'success' | 'warning' | 'error' | 'info' | 'tertiary';

export type TagStatus = 'default' | 'selected';

@Component({
  selector: 'ui-tag',
  imports: [ CommonModule, InlineSvgComponent ],
  templateUrl: './tag.component.html',
  styleUrl: './tag.component.scss',
})
export class TagComponent {
  /** The color variant of the tag (badge variant). */
  color = input<TagColor>('info');
  /** Specifies the status of the tag (selectable chip variant). */
  status = input<TagStatus>('default');
  /** Determines if the tag renders as a selectable chip with an icon. */
  icon = input<boolean>(false);
  /** Whether a selected chip shows its close icon. */
  removable = input<boolean>(true);

  /** Emitted when the close icon of a selected chip is pressed; the chip's own click is not. */
  remove = output<void>();

  onRemove(event: MouseEvent): void {
    event.stopPropagation();
    this.remove.emit();
  }
}
